import "@/App.css";
import { Citrus, Heart, ExternalLink, Users, Gift } from "lucide-react";

// Assets
const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_cogumays-creator/artifacts/z7gfw8x7_Download.mp4";
const GALLERY_IMAGE_1 = "https://customer-assets-gfyr7b9c.emergentagent.net/job_cogumays-creator/artifacts/kkpqhzug_WhatsApp%20Image%202026-09-08%20at%2012.02.47.jpeg";
const GALLERY_IMAGE_2 = "https://customer-assets.emergentagent.com/job_cogumays-creator/artifacts/11c7s1xc_WhatsApp%20Image%202026-04-10%20at%2015.10.46.jpeg";
const GALLERY_IMAGE_3 = "https://customer-assets-gfyr7b9c.emergentagent.net/job_cogumays-creator/artifacts/hj93201a_WhatsApp%20Image%202026-09-08%20at%2012.03.42.jpeg";
const GALLERY_VIDEO_1 = "/media/galeria-video-1.mp4";

// Links
const PRIVACY_LINK = "https://privacy.com.br/checkout/cogumays";
const ONLYFANS_LINK = "https://onlyfans.com/cogumays/c1";
const TELEGRAM_LINK = "https://t.me/+n42UKB8_JjtiNmEx";
const AMAZON_LINK = "https://www.amazon.com.br/hz/wishlist/ls/YSVTX8X0CMS9?ref_=wl_share";

// Link Buttons
const LinkButtons = () => {
  const links = [
    {
      id: "privacy",
      name: "Laranjinha",
      url: PRIVACY_LINK,
      icon: Citrus,
      testId: "privacy-link"
    },
    {
      id: "onlyfans",
      name: "Site Azul",
      url: ONLYFANS_LINK,
      icon: Heart,
      testId: "onlyfans-link"
    },
    {
      id: "telegram",
      name: "Telegram",
      url: TELEGRAM_LINK,
      icon: Users,
      testId: "telegram-link"
    },
    {
      id: "amazon",
      name: "Me envie um mimo",
      url: AMAZON_LINK,
      icon: Gift,
      testId: "amazon-link"
    }
  ];

  return (
    <div className="flex flex-col gap-3 w-full max-w-sm">
      {links.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={link.testId}
          className="link-btn"
        >
          <div className="flex items-center gap-3">
            <link.icon className="w-5 h-5 text-[#D91627]" />
            <span className="text-base text-[#F5EBEB]">{link.name}</span>
          </div>
          <ExternalLink className="w-4 h-4 text-[#A38F8F]" />
        </a>
      ))}
    </div>
  );
};

// Gallery
const GallerySection = () => {
  const media = [
    { type: "image", src: GALLERY_IMAGE_1, alt: "Cogumays - Foto 1" },
    { type: "video", src: GALLERY_VIDEO_1, alt: "Cogumays - Video 1" },
    { type: "image", src: GALLERY_IMAGE_3, alt: "Cogumays - Foto 3" },
    { type: "image", src: GALLERY_IMAGE_2, alt: "Cogumays - Foto 2" }
  ];

  return (
    <div className="grid grid-cols-2 gap-3 w-full max-w-sm mt-6">
      {media.map((item, index) => (
        <a
          key={index}
          href={PRIVACY_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="gallery-item"
          data-testid={`gallery-item-${index + 1}`}
        >
          {item.type === "image" ? (
            <img
              src={item.src}
              alt={item.alt}
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />
          ) : (
            <video
              src={item.src}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
            />
          )}
        </a>
      ))}
    </div>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-[#0A0303]" data-testid="main-app">
      {/* Hero - First Fold */}
      <section className="hero-section" data-testid="hero-section">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="hero-video"
          data-testid="hero-video"
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div className="hero-overlay" />
        
        <div className="hero-content">
          <h1 className="font-serif text-4xl sm:text-5xl font-light text-[#F5EBEB] mb-1" data-testid="hero-title">
            Cogumays
          </h1>
          <p className="text-xs text-[#A38F8F] tracking-widest uppercase mb-5" data-testid="hero-subtitle">
            Conteúdo Exclusivo
          </p>
          <LinkButtons />
          <GallerySection />
        </div>
      </section>

      {/* Footer */}
      <footer className="py-4 px-4 border-t border-[#331212] text-center" data-testid="footer">
        <p className="text-[#A38F8F] text-xs mb-1">
          © {new Date().getFullYear()} Cogumays
        </p>
        <p className="text-[#A38F8F]/60 text-xs">
          Criado por <a href="https://www.altaagency.com.br" target="_blank" rel="noopener noreferrer" className="hover:text-[#D91627] transition-colors">Alta Agency</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
